module.exports = __webpack_public_path__ + "static/media/view exclusion.036aa5ce.svg";